import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/images/Mishti_Holidays_transparent.png';
import { FaInstagram } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <img src={logo} alt="Mishti Holidays" className="footer__logo-img" />
          <div className="footer__collab">In Collaboration with <strong>Onaara Tours</strong></div>
          <p className="footer__tagline">Tailor Made Holidays · Comfortable Travel · Unmatched Experiences</p>
          <div className="footer__badges">
            <span>🌿 Sustainable</span><span>🛕 Cultural</span><span>🦁 Wildlife-Friendly</span>
          </div>
          <div className="footer__social" style={{justifyContent:'flex-start'}}>
        
         <a href="https://www.instagram.com/holidaysmishti?igsh=YWgzdWVha2FpM21u"
          target="_blank"
          rel="noreferrer"
          className="footer__social-btn"
          title="Follow us on Instagram"
        >
          <FaInstagram />
        </a>
      </div>
        </div>
        <div className="footer__col">
          <h4>Explore</h4>
          <ul>
            {[['Places','/places'],['Packages','/packages'],['Hotels','/hotels'],['Food','/food'],['Vehicles','/vehicles'], ['Cancellation Policy', '/cancellation-policy'],['Terms & Conditions', '/terms'],].map(([l,to])=>(
              <li key={to}><Link to={to}>{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="footer__col">
          <h4>Packages</h4>
          <ul>
            {[['Honeymoon Packages','/packages'],['Family Trips','/packages'],['Corporate Tours','/packages'],['Custom Itineraries','/packages']].map(([l,to])=>(
              <li key={l}><Link to={to}>{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="footer__col">
          <h4>Contact Us</h4>
          <ul className="footer__contact">
           <li>📍 No:11, 1st Floor, 17th Main,<br />JP Nagar 2nd Phase,<br />Bangalore 560078</li>
            <li>📞 <a href="tel:9740749793">9740749793</a></li>
            <li>📞 <a href="tel:9483549793">9483549793</a></li>
            <li>💬 WhatsApp Available</li>
            <li>✉️ <a href="mailto:support@mishtiholidays.com">support@mishtiholidays.com</a></li>
          </ul>
        </div>
      </div>
     
      
      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} <strong>Mishti Holidays</strong>. All rights reserved.</p>
        <p>We make your holiday <em>Simply Amazing!</em></p>
      </div>
    </footer>
  );
}
